const translations = {
  'studentVisas.seo.title': 'TEFL Courses in Barcelona & Student Visa Assistance | 2025',
  'studentVisas.seo.description':
    'Our courses are eligible for long-term Spanish student visas, visa renewals and extensions. Visa and work permits in Spain, 96% visa approval rate.',
  'studentVisas.sec1.title': 'Student Visa Programmes',
  'studentVisas.sec1.description':
    'Our Student Visa Programmes allow you to live and work in Spain whilst you study.',
  'studentVisas.sec2.title': 'Living and Working in Barcelona Has Never Been Easier',
  'studentVisas.sec2.description':
    'If you are a European citizen or have a European passport you are free to work in Spain without a visa. If you are a non-EU citizen you will need a visa to live and work in Spain. You can do the one month TEFL course on a tourist visa, but if you are planning to stay in Barcelona for longer than three months you won’t be covered by your tourist visa.',

  'studentVisas.sec3.op1.title': 'If You Want To Get Qualified As A Teacher',
  'studentVisas.sec3.op1.description': 'You have two options for obtaining a student visa:',
  'studentVisas.sec3.op2.title': 'If You Are Already Qualified As A Teacher',
  'studentVisas.sec3.op2.description': 'You have two options for obtaining a student visa:',
  'studentVisas.sec3.findOutMore': 'Find out more about our Developing Teacher course',
  'studentVisas.sec3.notice': 'See our <a> dates and fees page </a> for more information.',

  'studentVisas.sec4.title': 'Long-term courses explained',
  'studentVisas.sec4.description':
    'In order to qualify for a long-term student visa you must sign up to a course that is at least 20 hours/week and 7-12 months long. At TEFL Iberia we have developed two courses to meet this requirement:',
  'studentVisas.sec4.b1.title': 'The Developing Teacher Course',
  'studentVisas.sec4.b1.text1':
    'This is an advanced TEFL course aimed at those who already have some TEFL training / work experience and want to deepen their subject knowledge and brush up on their skills.',
  'studentVisas.sec4.b1.text2':
    'It involves a mixture of in-person workshops, senior teacher observations, webinars, reflective tasks and independent study.',
  'studentVisas.sec4.b1.text3':
    'You will also gain access to our active community of Barcelona teachers, to share advice, job opportunities, guidance on Spanish bureaucracy, flat share opportunities and more.',
  'studentVisas.sec4.b1.price': '<b>150€</b> per month or <b2>1500€</b2> for 1 year',
  'studentVisas.sec4.b2.title': 'Spanish and Developing Teacher Course',
  'studentVisas.sec4.b2.text1':
    'This course has all the benefits of the Developing Teacher course, plus 10 hours per week of Cervantes accredited Spanish classes in our partner school.',
  'studentVisas.sec4.b2.text2':
    'Studying Spanish for 10 hours per week will take you from complete beginner to fluency in under 12 months. Gain another skill and get the most out of your experience in Spain with this option!',
  'studentVisas.sec4.b2.price': '<b>275€</b> per month or <b2>3000€</b2> for 1 year',

  'studentVisas.sec5.title': 'What Makes Our Visa Service Different?',
  'studentVisas.sec5.b1.title': 'Before you set off:',
  'studentVisas.sec5.b1.ben1': 'Detailed guidance on how to gather all the necessary paperwork.',
  'studentVisas.sec5.b1.ben2': 'Help completing the Spanish application form.',
  'studentVisas.sec5.b1.ben3': 'Special discount on health insurance for TEFL Iberia students',
  'studentVisas.sec5.b1.ben4': 'Courier delivery of your school enrolment letter.',
  'studentVisas.sec5.b1.ben5': 'Fast delivery of your school enrolment letter.',
  'studentVisas.sec5.b1.ben6':
    '96% success rate in processing student visas and minimal rejections.',

  'studentVisas.sec5.b2.title': 'Once you are in Barcelona:',
  'studentVisas.sec5.b2.ben1':
    'We will book your TIE appointment for you (read more about the TIE <a>here</a>). These appointments are notoriously hard to come by and we’ll save you alot of hassle.',
  'studentVisas.sec5.b2.ben2':
    'A contact from the school will personally accompany you to the foreign office to help with paperwork and translations.',
  'studentVisas.sec5.b2.ben3':
    'The school will give you ongoing guidance on how and where to get all the necessary documents to get your student card (TIE - Tarjeta de identidad de extranjero).',
  'studentVisas.sec5.b2.text':
    'Student card (TIE) and housing register (empadronamiento) booking and accompaniment to appointments have an additional cost of 160€.',

  'studentVisas.sec6.title': 'What Documents Do I Need?',
  'studentVisas.sec6.benText': 'The Spanish consulate requires the following documents:',
  'studentVisas.sec6.ben1': 'Passport, valid for 6 months beyond your stay in Spain.',
  'studentVisas.sec6.ben2': 'Spanish student visa application form (<a>downloadable pdf</a>)',
  'studentVisas.sec6.ben3': '2 x passport photos.',
  'studentVisas.sec6.ben4':
    'Enrolment letter from the school (you get this from us once you are accepted onto the course).',
  'studentVisas.sec6.ben5': 'Criminal background check.',
  'studentVisas.sec6.ben6': 'Proof of course payment in full.',
  'studentVisas.sec6.ben7': 'Medical certificate.',
  'studentVisas.sec6.ben8': 'Medical insurance.',
  'studentVisas.sec6.ben9': 'Proof of sufficient funds to support yourself during your stay.',
  'studentVisas.sec6.ben10': 'Proof of address in your home country.',

  'studentVisas.sec7.title': 'Got Questions? <accent>Ask Us Anything.</accent>',
  'studentVisas.sec7.text1':
    ' If you would like to discuss the process in more detail you are welcome to contact <a>coordination@tefl-iberia.com</a> with questions or <a2>complete the form</a2> to book an appointment or video call.',
  'studentVisas.sec7.text2':
    'If you would like to read about recent, first-hand experiences we highly recommend joining the <a>Barcelona TEFL Teachers’ Association page </a>.  It is a very active online community with tons of non-EU teachers and TEFL trainees sharing their experiences. If you use its search function on the top right-hand corner of the page to search, for example, ‘student visa’, you’ll find lots of active discussions.',
};

export default translations;
